import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !*** REPORTS API CONFIG                                         ***!
  \*******************************************************************************/

export const apiConfig = {
  RunReports: BOM.baseUrl("runreports"),
  Reports: BOM.baseUrl("reports"),
};

//
/*!*******************************************************************************!
  !*** REPORTS LABEL CONFIG                                                       ***!
  \*******************************************************************************/

export const labelConfig = {
  loanReports: "Loan Reports",
  financeReports: "Finance Reports",
  complianceReports: "Compliance Reports",
  walletReports: "Wallet Reports",
  depositReports: "Deposit Reports",
  securityReports: "Security Reports",
  operationReports: "Operation Reports",
  treasuryReports: "Treasury Reports",
  paymentReports: "Payment Reports",
  agencyBankingReports: "Agency Banking Reports",
  casaReports: "Current and Savings Accounts Reports",
  reports: "Reports",
  runReport: "Run Report",
  currency: "Currency",
  fund: "Fund",
  loanPurpose: "Loan Purpose",
  office: "Office",
  decimalPlaces: "Decimal Places",
  customerReports: "Customer Reports",
  customReports: "Custom Reports",
  newReport: "New Report",
  updateReport: "Update Report",
  manageLoanReports: "Manage Loan Reports",
  reportDetails: "Report Details",
  // editReport: "Report Details",
  reportParameters: "Report Parameters",
  reportName: "Report Name",
  reportCategory: "Report Category",
  reportType: "Report Type",
  reportSubType: "Report Sub Type",
  add: "Add",
  parameter: "Parameter",
  description: "Description",
  parameterName: "Parameter Name",
  SQL: "SQL",
  // reportSubType: "Report Sub Type",
};

/*!*******************************************************************************!
    !*** REPORTS STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  decimalPlacesData: [
    { value: 0, label: "Zero decimal places" },
    { value: 1, label: "4" },
    { value: 2, label: "3" },
    { value: 3, label: "2" },
    { value: 4, label: "1" },
    { value: 5, label: "0" },
  ],
  manageLoanReportsBreadcrumbItems: [{ title: labelConfig.loanReports }],
  detailLoanReportsBreadcrumbItems: [
    { title: <Link to="/loanReport">{labelConfig.loanReports}</Link> },
    { title: "Report Detail" },
  ],
  manageCasaReportsBreadcrumbItems: [{ title: labelConfig.casaReports }],
  detailCasaReportsBreadcrumbItems: [
    { title: <Link to="/casa-reports">{labelConfig.casaReports}</Link> },
    { title: "Report Detail" },
  ],
  runCasaReportsBreadcrumbItems: [
    { title: <Link to="/casa-reports">{labelConfig.casaReports}</Link> },
    { title: labelConfig.runReport },
  ],
  manageFinanceReportsBreadcrumbItems: [{ title: labelConfig.financeReports }],

  runFinanceReportsBreadcrumbItems: [
    { title: <Link to="/finance-reports">{labelConfig.financeReports}</Link> },
    { title: labelConfig.runReport },
  ],

  manageDepositReportsBreadcrumbItems: [{ title: labelConfig.depositReports }],
  runDepositReportsBreadcrumbItems: [
    { title: <Link to="/deposit-reports">{labelConfig.depositReports}</Link> },
    { title: labelConfig.runReport },
  ],

  manageSecurityReportsBreadcrumbItems: [{ title: labelConfig.securityReports }],
  runSecurityReportsBreadcrumbItems: [
    { title: <Link to="/security-reports">{labelConfig.securityReports}</Link> },
    { title: labelConfig.runReport },
  ],

  manageOperationsReportsBreadcrumbItems: [{ title: labelConfig.operationReports }],
  runOperationsReportsBreadcrumbItems: [
    { title: <Link to="/operations-reports">{labelConfig.operationReports}</Link> },
    { title: labelConfig.runReport },
  ],

  manageTreasuryReportsBreadcrumbItems: [{ title: labelConfig.treasuryReports }],
  runTreasuryReportsBreadcrumbItems: [
    { title: <Link to="/treasury-reports">{labelConfig.treasuryReports}</Link> },
    { title: labelConfig.runReport },
  ],

  managePaymentsReportsBreadcrumbItems: [{ title: labelConfig.paymentReports }],
  runPaymentsReportsBreadcrumbItems: [
    { title: <Link to="/payments-reports">{labelConfig.paymentReports}</Link> },
    { title: labelConfig.runReport },
  ],

  manageAgencyBankingReportsBreadcrumbItems: [{ title: labelConfig.agencyBankingReports }],
  runAgencyBankingReportsBreadcrumbItems: [
    { title: <Link to="/agency-banking-reports">{labelConfig.agencyBankingReports}</Link> },
    { title: labelConfig.runReport },
  ],

  manageWalletReportsBreadcrumbItems: [{ title: labelConfig.walletReports }],
  runWalletReportsBreadcrumbItems: [
    { title: <Link to="/wallet-reports">{labelConfig.walletReports}</Link> },
    { title: labelConfig.runReport },
  ],

  manageComplianceReportsBreadcrumbItems: [{ title: labelConfig.complianceReports }],
  runComplianceReportsBreadcrumbItems: [
    { title: <Link to="/compliance-reports">{labelConfig.complianceReports}</Link> },
    { title: labelConfig.runReport },
  ],

  manageCustomerReportsBreadcrumbItems: [{ title: labelConfig.customerReports }],
  detailCustomerReportsBreadcrumbItems: [
    { title: <Link to="/customer-reports">{labelConfig.customerReports}</Link> },
    { title: "Report Detail" },
  ],
  managePaymentTypeItems: [{ title: labelConfig.managePaymentType }],
  manageCustomReportsBreadcrumbItems: [{ title: labelConfig.customReports }],
  viewCustomReportsBreadcrumbItems: [
    { title: <Link to="/custom-report-builder">{labelConfig.customReports}</Link> },
    { title: labelConfig.customReports },
  ],
  createCustomReportsBreadcrumbItems: [
    { title: <Link to="/custom-report-builder">{labelConfig.customReports}</Link> },
    { title: labelConfig.newReport },
  ],
  detailCustomReportsBreadcrumbItems: [
    { title: <Link to="/custom-report-builder">{labelConfig.customReports}</Link> },
    { title: labelConfig.reportDetails },
  ],
  runCustomerReportsBreadcrumbItems: [
    { title: <Link to="/customer-reports">{labelConfig.customerReports}</Link> },
    { title: labelConfig.runReport },
  ],
  editCustomReportsBreadcrumbItems: [
    { title: <Link to="/custom-report-builder">{labelConfig.customReports}</Link> },
    { title: labelConfig.updateReport },
  ],
  runLoanReportsBreadcrumbItems: [
    { title: <Link to="/loan-reports">{labelConfig.loanReports}</Link> },
    { title: labelConfig.runReport },
  ],
};

export const GetLabelForReportParameter = (parameterName) => {
  const parameterLabels = {
    startDateSelect: "Start Date",
    endDateSelect: "End Date",
    obligDateTypeSelect: "Obligation Date Type",
    OfficeIdSelectOne: "Office",
    loanOfficerIdSelectAll: "Loan Officer",
    currencyIdSelectAll: "Currency",
    fundIdSelectAll: "Fund",
    loanProductIdSelectAll: "Loan Product",
    loanPurposeIdSelectAll: "Loan Purpose",
    parTypeSelect: "PAR Type",
    selectAccount: "Select Account",
    savingsProductIdSelectAll: "Savings Product",
    transactionId: "Transaction ID",
    selectCenterId: "Select Center",
    SelectGLAccountNO: "GL Account Number",
    asOnDate: "As On Date",
    SavingsAccountSubStatus: "Savings Account Sub-Status",
    cycleXSelect: "Cycle X",
    cycleYSelect: "Cycle Y",
    fromXSelect: "From X",
    toYSelect: "To Y",
    overdueXSelect: "Overdue X",
    overdueYSelect: "Overdue Y",
    DefaultLoan: "Default Loan",
    DefaultClient: "Default Client",
    DefaultGroup: "Default Group",
    SelectLoanType: "Select Loan Type",
    DefaultSavings: "Default Savings",
    DefaultSavingsTransactionId: "Default Savings Transaction ID",
    SelectParentGl: "Parent GL",
    selectGlType: "GL Type",
    selectStatus: "Status",
    depositType: "Deposit Type",
    selectBranch: "Select Branch",
    selectClientStatus: "Select Client Status",
    selectDepositType: "Select Deposit Type",
  };

  return parameterLabels[parameterName] || parameterName;
};
